import React, { useState, useEffect } from 'react'
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import MeetingForm from "./component/MeetingForm";
import { getBD_Names } from "../Services/ApiCalling";

const MeetingFormView = () => {

    const token = localStorage.getItem("LoginToken");
    const [bd_names, setBd_names] = useState([]);
    const [load, setLoad] = useState(false);

    const fetch_bd_Names = async () => {

        setLoad(true);
        try {
            const resppp = await getBD_Names(token);
            if (resppp?.data) {
                const opts = resppp.data.map(emp => ({
                    label: emp.Name,
                    value: emp.Name
                }));
                setBd_names(opts)
            } else {
                toast.success("Something went wrong !", { position: "top-center" });
            }

        } catch (error) {
            console.error("Failed to fetch data", error);
        } finally {
            setLoad(false);
        }

    }

    useEffect(() => {
        fetch_bd_Names();
    }, [])

    console.log("bd_namesssss", bd_names);

    return (
        <>
            <MeetingForm bd_names={bd_names || []} load={load} />
            < ToastContainer />
        </>
    )
}

export default MeetingFormView